import { AxiosResponse } from "axios";
import { FormikValues } from "formik";
import http from "utilities/http-common";
const baseUrl = "/api/Processors";


export async function getProcessors(role: string): Promise<Processor[]> {
    const params = new URLSearchParams();
    params.append("role", role);

    return http
    .get(baseUrl, { params: params })
    .then((resp: AxiosResponse<Processor[]>) => {
      return resp.data;
    });
}

export interface CompleteApplicationParameters {
  applicationId: string | undefined;
  isDevRequest: boolean;
  values?: FormikValues;
  json?: {};
}

